<script lang="ts">
import { type Component, defineAsyncComponent, defineComponent } from "vue";

const componentFiles = import.meta.glob<Component>(
  [
    "@/**/*.vue",
    "!@/App.vue",

    // Views paths are lazy-imported vue-router
    "!@/views/**/*.vue",
    // Layouts are only used by SPA
    "!@/layouts/**/*.vue"
  ],
  {
    eager: true,
    import: "default"
  }
);

const components = Object.entries(componentFiles).reduce((result, [path, component]) => {
  const name = path.substring(path.lastIndexOf("/") + 1, path.lastIndexOf("."));
  return { ...result, [name]: component };
}, {});

const viewComponentFiles = import.meta.glob<Component>(["@/views/**/*.vue", "@/layouts/**/*.vue"]);

const viewComponents = Object.entries(viewComponentFiles).reduce((result, [path, component]) => {
  const name = path.substring(path.lastIndexOf("/") + 1, path.lastIndexOf("."));
  return { ...result, [name]: defineAsyncComponent(component) };
}, {});

export default defineComponent({
  components: {
    ...components,
    ...viewComponents
  },
  compilerOptions: {
    isCustomElement(tag) {
      return tag.startsWith("ng-") || ["progressbar"].includes(tag);
    }
  }
});
</script>

<style lang="less">
@import "@dsk/styles/colors";
@import "@dsk/styles/alert";
@import "@/assets/styles/page-fade";

.js-focus-visible :focus:not(.focus-visible) {
  outline: none;
}

.lemue-page {
  height: 100%;
  background-color: @colors[@secondary][300];

  &__app {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__content {
    flex: 1 0 auto;
  }

  &__footer {
    flex-shrink: 0;
  }
}
</style>
